function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import PropTypes from 'prop-types';
import React from 'react';

var RatingStars = function RatingStars(_ref) {
  var ratingValue = _ref.ratingValue,
      onRatingStarClick = _ref.onRatingStarClick,
      onRatingLabelClick = _ref.onRatingLabelClick,
      ratingLabelText = _ref.ratingLabelText,
      ratingStarColor = _ref.ratingStarColor;
  var fullStars = Math.floor(ratingValue);
  var halfStars = ratingValue % 1 !== 0 ? 1 : 0;
  var emptyStars = 5 - (fullStars + halfStars);
  return /*#__PURE__*/React.createElement("div", {
    className: "rating"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rating__number rating__number--visible",
    onClick: onRatingLabelClick
  }, ratingLabelText), _toConsumableArray(Array(fullStars)).map(function (x, i) {
    return /*#__PURE__*/React.createElement("i", {
      className: "rating__icon icon icon-star icon-".concat(ratingStarColor),
      key: i,
      onClick: function onClick() {
        onRatingStarClick(i + 1);
      }
    });
  }), _toConsumableArray(Array(halfStars)).map(function (x, i) {
    return /*#__PURE__*/React.createElement("i", {
      className: "rating__icon icon icon-star-half-o icon-".concat(ratingStarColor),
      key: i,
      onClick: function onClick() {
        onRatingStarClick(i + 1 + fullStars);
      }
    });
  }), _toConsumableArray(Array(emptyStars)).map(function (x, i) {
    return /*#__PURE__*/React.createElement("i", {
      className: "rating__icon icon icon-star-o icon-".concat(ratingStarColor),
      key: i,
      onClick: function onClick() {
        onRatingStarClick(i + 1 + fullStars + halfStars);
      }
    });
  }));
};

RatingStars.displayName = "RatingStars";
RatingStars.propTypes = {
  ratingValue: PropTypes.number,
  ratingStarColor: PropTypes.string,
  ratingLabelText: PropTypes.string,
  onRatingStarClick: PropTypes.func,
  onRatingLabelClick: PropTypes.func
};
RatingStars.defaultProps = {
  ratingValue: 5,
  ratingStarColor: 'yellow',
  ratingLabelText: '',
  onRatingStarClick: function onRatingStarClick() {},
  onRatingLabelClick: function onRatingLabelClick() {}
};
export default RatingStars;